var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import React from 'react';
import { useSelector } from 'react-redux';
import { TemplateType } from '@debbie/common/dist/templates';
import { c } from '@debbie/cortex/dist';
import { Search } from '../..';
import { Modal } from '../../index';
import EmailPreview from '../../interactions/EmailPreview';
import { parseText } from '../../../utils/templates';
import ObjectComp from '../../ObjectComp';
const PreviewModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const caseId = props.caseId;
    return (React.createElement(Modal, { header: lang.templates.preview, onToggle: props.toggleModal },
        React.createElement(Search, { removeWrapper: true, onSelect: (result) => __awaiter(void 0, void 0, void 0, function* () {
                if (result.objectID) {
                    props.setCaseId(result.objectID);
                }
            }) }),
        props.template &&
            [TemplateType.LETTER, TemplateType.EBOKS].includes(props.template.type) &&
            caseId ? (React.createElement(ObjectComp, { key: caseId, type: "application/pdf", url: c.templates.genPreviewUrl(props.templateId, caseId, props.template.versionId, {
                body: parseText(draftToHtml(convertToRaw(props.editorState.getCurrentContent())), lang.mentions),
            }) })) : props.template &&
            (props.template.type === TemplateType.EMAIL ||
                props.template.type === TemplateType.SMS ||
                props.template.type === TemplateType.AUTOCALL) &&
            props.caseId ? (React.createElement(EmailPreview, { key: caseId, options: {
                caseId: props.caseId,
                html: props.editorState,
                subject: props.template.type === TemplateType.EMAIL
                    ? props.subjectState
                    : null,
            } })) : (React.createElement("h3", { style: {
                margin: '4em 0',
                opacity: 0.7,
                textAlign: 'center',
            } }, lang.templates.selectTestCase))));
};
export default PreviewModal;
//# sourceMappingURL=PreviewModal.js.map